import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  padding: 0px 20px 80px 20px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

export const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  align-self: stretch;
`;

export const FilterContainer = styled.div`
  display: flex;
  padding: 0px 20px;
  flex-direction: column;
  align-items: flex-end;
  gap: 20px;
  align-self: stretch;

  .filter-box {
    display: flex;
    padding: 20px 16px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    gap: 16px;
    align-self: stretch;

    border-radius: 16px;
    border: 1px solid var(--alias-color-line-normal);
  }

  .label {
    display: flex;
    width: 120px;
    align-items: center;
  }

  .filter-form {
    display: flex;
    padding: 4px 12px;
    align-items: center;
    gap: 8px;
    align-self: stretch;
  }
`;

export const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 48px;
  width: 100%;
`;
